import { render } from "./ClassCalendar.vue?vue&type=template&id=24c9530b&scoped=true"
import script from "./ClassCalendar.vue?vue&type=script&lang=js"
export * from "./ClassCalendar.vue?vue&type=script&lang=js"

import "./ClassCalendar.vue?vue&type=style&index=0&id=24c9530b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c9530b"]])

export default __exports__